import {createI18n} from 'vue-i18n'

import messages from '../../locales'
import {useConfig} from "@/composables/config";

let i18nInstance: any

export default {
  install: (app: App) => {
    const config = useConfig()

    i18nInstance = createI18n({
      locale: config.locales.default,
      fallbackLocale: config.locales.default,
      messages,
      legacy: false
    })

    app.use(i18nInstance)

    // register $t as global property
    app.config.globalProperties.$t = i18nInstance.global.t
  }
}